import { useEffect, useRef } from 'react'
import { useRouter } from 'next/router'
import { useAuthState } from '../contexts/AuthContext'
import { NextPaths } from '../router/next-paths'
import { useAuthRedirect } from '../components/auth/shared/utils'

// Each app owns its own login surface on its own origin (see
// next.config.base crossAppRedirects / APP_SECTIONS). The root index must send
// unauthenticated users to THIS app's login — otherwise the cross-app redirect
// bounces them to the provider's /login (e.g. operation → app-dev/login).
const LOGIN_BY_APP: Record<string, string> = {
  Operation: NextPaths.superAdminLogin, // /operation/login
  Customer: NextPaths.oauthLogin, // /auth/login
}

export default function IndexPage() {
  const router = useRouter()
  const auth = useAuthState()
  const { redirectAfterAuth } = useAuthRedirect()
  const hasRedirectedRef = useRef(false)

  useEffect(() => {
    if (hasRedirectedRef.current) return
    if (auth.isLoading) return

    hasRedirectedRef.current = true

    const appName = process.env.NEXT_PUBLIC_APP_NAME as string

    if (!auth.isAuthenticated) {
      router.replace(LOGIN_BY_APP[appName] || NextPaths.login)
      return
    }

    // Operation is a super-admin-only app; its home and auth gating live under
    // /operation (OperationLayout re-checks and bounces non-super-admins). The
    // provider-centric redirectAfterAuth (/provider/home | /admin/home) would
    // land off-origin here, so route operation to its own dashboard.
    if (appName === 'Operation') {
      router.replace(NextPaths.superAdminDashboard)
      return
    }

    redirectAfterAuth(auth.user?.type)
  }, [auth.isAuthenticated, auth.isLoading, auth.user?.type, redirectAfterAuth, router])

  return null
}
